// Libraries
import React from 'react';
import {findDOMNode} from 'react-dom';
import {css} from 'aphrodite/no-important';
import katex from 'katex';
import 'katex/dist/katex.min.css';
import $ from 'jquery';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';

const commonStyles = {
    padding: 0,
    margin: 0,
    fontWeight: 400,
    color: CoreMetrics.Color.LightUI.PrimaryText,
    "-webkit-font-smoothing": "antialiased",
    "-moz-osx-font-smoothing": "antialiased",
};

// Base components

class Text extends React.Component {
    render() {
        const {font, size, lineHeight, tag, html, title, children} = this.props;

        const styles = createExpandableMediaQueryStylesheet({
            text: {
                ...commonStyles,
                fontFamily: font,
                fontSize: size,
                lineHeight: lineHeight,
            },
        });

        const Tag = tag; // Variable name needs to be capitalized (see https://stackoverflow.com/a/33471928)
        let combinedStyles = [styles.text, ...this.props.styles];
        return html
            ? <Tag
                className={css(combinedStyles)}
                title={title}
                dangerouslySetInnerHTML={{__html: html}} />
            : <Tag className={css(combinedStyles)} title={title}>
                {children}
            </Tag>;
    }
}
Text.defaultProps = {
    styles: [],
    tag: `p`,
    font: CoreMetrics.Type.Font.SansSerifRegular,
    size: CoreMetrics.Type.SansSerif.Medium.Size(),
    lineHeight: CoreMetrics.Type.SansSerif.Medium.LineHeight(),
    title: "Text",
};


// Semantic type styles

export class DemoLabel extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            demoLabel: {
                color: CoreMetrics.Color.Debug,
            },
        });
        let combinedStyles = [styles.demoLabel, ...this.props.styles];
        return (
            <Text
                size={CoreMetrics.Type.SansSerif.Small.Size()}
                lineHeight={CoreMetrics.Type.SansSerif.Small.LineHeight()}
                styles={combinedStyles}
                title="DemoLabel"
            >
                {this.props.children}
            </Text>
        );
    }
}
DemoLabel.defaultProps = {
    styles: [],
};

export class TitleText extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            title: {
            },
        });
        let combinedStyles = [styles.title, ...this.props.styles];
        return (
            <Text
                font={CoreMetrics.Type.Font.SansSerifMedium}
                size={CoreMetrics.Type.SansSerif.XXLarge.Size()}
                lineHeight={CoreMetrics.Type.SansSerif.XXLarge.LineHeight()}
                styles={combinedStyles}
                title="Title"
            >
                {this.props.children}
            </Text>
        );
    }
}
TitleText.defaultProps = {
    styles: [],
};

export class TaglineText extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            tagline: {
            },
        });
        let combinedStyles = [styles.tagline, ...this.props.styles];
        return (
            <Text
                size={CoreMetrics.Type.SansSerif.Large.Size()}
                lineHeight={CoreMetrics.Type.SansSerif.Large.LineHeight()}
                styles={combinedStyles}
                title="Tagline"
            >
                {this.props.children}
            </Text>
        );
    }
}
TaglineText.defaultProps = {
    styles: [],
};

export class HeadingLargeText extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            headingLarge: {
            },
        });
        let combinedStyles = [styles.headingLarge, ...this.props.styles];
        return (
            <Text
                font={CoreMetrics.Type.Font.SansSerifMedium}
                size={CoreMetrics.Type.SansSerif.XLarge.Size()}
                lineHeight={CoreMetrics.Type.SansSerif.XLarge.LineHeight()}
                styles={combinedStyles}
                title="HeadingLarge"
            >
                {this.props.children}
            </Text>
        );
    }
}
HeadingLargeText.defaultProps = {
    styles: [],
};

export class HeadingMediumText extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            headingMedium: {
            },
        });
        let combinedStyles = [styles.headingMedium, ...this.props.styles];
        return (
            <Text
                font={CoreMetrics.Type.Font.SansSerifMedium}
                size={CoreMetrics.Type.SansSerif.Large.Size()}
                lineHeight={CoreMetrics.Type.SansSerif.Large.LineHeight()}
                styles={combinedStyles}
                title="HeadingMedium"
            >
                {this.props.children}
            </Text>
        );
    }
}
HeadingMediumText.defaultProps = {
    styles: [],
};

export class HeadingSmallText extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            headingSmall: {
                color: CoreMetrics.Color.LightUI.SecondaryText,
            },
        });
        let combinedStyles = [styles.headingSmall, ...this.props.styles];
        return (
            <Text
                font={CoreMetrics.Type.Font.SansSerifMedium}
                size={CoreMetrics.Type.SansSerif.Large.Size()}
                lineHeight={CoreMetrics.Type.SansSerif.Large.LineHeight()}
                styles={combinedStyles}
                title="HeadingSmall"
            >
                {this.props.children}
            </Text>
        );
    }
}
HeadingSmallText.defaultProps = {
    styles: [],
};

export class BodyText extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            body: {
            },
        });
        let combinedStyles = [styles.body, ...this.props.styles];
        return (
            <Text
                tag={this.props.tag}
                size={CoreMetrics.Type.SansSerif.Medium.Size()}
                lineHeight={CoreMetrics.Type.SansSerif.Medium.LineHeight()}
                styles={combinedStyles}
                title="Body"
            >
                {this.props.children}
            </Text>
        );
    }
}
BodyText.defaultProps = {
    styles: [],
};

export class BodySerifText extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            bodySerif: {
            },
        });
        let combinedStyles = [styles.bodySerif, ...this.props.styles];
        return (
            <Text
                font={CoreMetrics.Type.Font.Serif}
                size={CoreMetrics.Type.Serif.Medium.Size()}
                lineHeight={CoreMetrics.Type.Serif.Medium.LineHeight()}
                styles={combinedStyles}
                title="BodySerif"
            >
                {this.props.children}
            </Text>
        );
    }
}
BodySerifText.defaultProps = {
    styles: [],
};

export class BodyMonospaceText extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            bodyMonospace: {
            },
        });
        let combinedStyles = [styles.bodyMonospace, ...this.props.styles];
        return (
            <Text
                font={CoreMetrics.Type.Font.Monospace}
                size={CoreMetrics.Type.Monospace.Medium.Size()}
                lineHeight={CoreMetrics.Type.Monospace.Medium.LineHeight()}
                styles={combinedStyles}
                title="BodyMonospace"
            >
                {this.props.children}
            </Text>
        );
    }
}
BodyMonospaceText.defaultProps = {
    styles: [],
};

export class LabelLargeText extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            uiBody: {
                fontWeight: 600,
            },
        });
        let combinedStyles = [styles.uiBody, ...this.props.styles];
        return (
            <Text
                font={CoreMetrics.Type.Font.SansSerifMedium}
                size={CoreMetrics.Type.SansSerif.Medium.Size()}
                lineHeight={CoreMetrics.Type.SansSerif.Medium.LineHeight()}
                styles={combinedStyles}
                title="LabelMedium"
            >
                {this.props.children}
            </Text>
        );
    }
}
LabelLargeText.defaultProps = {
    styles: [],
};

export class LabelMediumText extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            uiBody: {
            },
        });
        let combinedStyles = [styles.uiBody, ...this.props.styles];
        return (
            <Text
                font={CoreMetrics.Type.Font.SansSerifMedium}
                size={CoreMetrics.Type.SansSerif.Medium.Size()}
                lineHeight={CoreMetrics.Type.SansSerif.Medium.LineHeight()}
                styles={combinedStyles}
                title="LabelMedium"
            >
                {this.props.children}
            </Text>
        );
    }
}
LabelMediumText.defaultProps = {
    styles: [],
};

export class LabelSmallText extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            uiBody: {
            },
        });
        let combinedStyles = [styles.uiBody, ...this.props.styles];
        return (
            <Text
                size={CoreMetrics.Type.SansSerif.Small.Size()}
                lineHeight={CoreMetrics.Type.SansSerif.Small.LineHeight()}
                styles={combinedStyles}
                title="LabelSmall"
            >
                {this.props.children}
            </Text>
        );
    }
}
LabelSmallText.defaultProps = {
    styles: [],
};

export class CaptionText extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            caption: {
            },
        });
        let combinedStyles = [styles.caption, ...this.props.styles];
        return (
            <Text
                size={CoreMetrics.Type.SansSerif.Small.Size()}
                lineHeight={CoreMetrics.Type.SansSerif.Small.LineHeight()}
                styles={combinedStyles}
                title="Caption"
            >
                {this.props.children}
            </Text>
        );
    }
}
CaptionText.defaultProps = {
    styles: [],
};

export class FootnoteText extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            footnote: {
            },
        });
        let combinedStyles = [styles.footnote, ...this.props.styles];
        return (
            <Text
                size={CoreMetrics.Type.SansSerif.XSmall.Size()}
                lineHeight={CoreMetrics.Type.SansSerif.XSmall.LineHeight()}
                styles={combinedStyles}
                title="Footnote"
            >
                {this.props.children}
            </Text>
        );
    }
}
FootnoteText.defaultProps = {
    styles: [],
};


// Text components

export class MathText extends React.Component {
    static Variant = {
        Inline: "inline", // Default
        Block: "block",
    };
    render() {
        let {latex, variant} = this.props;
        let combinedStyles = [
            ...this.props.styles,
        ];
        let html = null;
        try {
            html = katex.renderToString(latex);
        } catch (e) {
            console.log("ERROR: Unable to render LaTeX string:", latex);
        }
        let tag = `span`;
        let size = CoreMetrics.Type.Serif.Medium.Size();
        let lineHeight = CoreMetrics.Type.Serif.Medium.LineHeight();
        if (variant === MathText.Variant.Block) {
            tag = `p`;
            size = CoreMetrics.Type.Serif.Large.Size();
            lineHeight = CoreMetrics.Type.Serif.Large.LineHeight();
        }

        return (
            <Text
                tag={tag}
                styles={combinedStyles}
                font={CoreMetrics.Type.Font.Serif}
                size={size}
                lineHeight={lineHeight}
                title="BodySerif"
                html={html}
            />
        );
    }
    componentDidMount() {
        this.updateStyling();
    }
    componentDidUpdate() {
        this.updateStyling();
    }
    updateStyling() {
        // Update the fill color
        const container = findDOMNode(this);
        if (container) {
            $(container).find("span").css({
                fontFamily: CoreMetrics.Type.Font.Serif,
            });
        }
    }
}
MathText.defaultProps = {
    latex: "$$",
    variant: MathText.Variant.Inline,
    styles: [],
};

export class CodeText extends React.Component {
    static Variant = {
        Inline: "inline", // Default
        Block: "block",
    };
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            code: {
                whiteSpace: "pre",
            },
        });
        let {variant} = this.props;
        let combinedStyles = [
            styles.code,
            ...this.props.styles,
        ];
        const tag = (variant === MathText.Variant.Block) ? `p` : `span`;

        return (
            <Text
                ref="container"
                tag={tag}
                styles={combinedStyles}
                font={CoreMetrics.Type.Font.Monospace}
                size={CoreMetrics.Type.Monospace.Medium.Size()}
                lineHeight={CoreMetrics.Type.Monospace.Medium.LineHeight()}
                title="BodyMonospace"
            >
                {this.props.children}
            </Text>
        );
    }
}
CodeText.defaultProps = {
    variant: CodeText.Variant.Inline,
    styles: [],
};



// WEBPACK FOOTER //
// ./src/core/Type.jsx